export class Primerka {

    constructor() {
        
        this.points = Array()
        this.ctx = null
        this.op = null

        this.canvasSetting = null
        this.canvasShow = null

    }

    checkRowSID() {
        let sid = this.get_cookie('PHPSESSID')
        // let _this = this
        if(sid !== undefined || sid !== '') {
            $.ajax({
                url: "/ajax.php?mid=1",
                type: 'POST',
                data: {
                    action: 'primerka_fartuka',
                    sid: sid,
                    },
                dataType: "json",
        
                success: function callbackName(res)
                {
                    if (res['success'])
                    {
                        let img
                        if(res['kitchen_src']) {
                            img = res['kitchen_src']
                        } else {
                            img = '/media/image_about.jpg'
                        }
                        $('img.popup-view__image').attr('src',img)
                        $('img.popup-fitting__set-image').attr('src',img)
                        $('.popup-fitting__step.popup-fitting__step--3 > .popup-fitting__step-teaser > .text-block > img').attr('src',img)
                    }
                    else
                    {
                        alert(res['error'])
                    }
                },
                // error: function(err){
                //     alert('Ошибка! Попробуйте повотрить запрос. Error: ' + err)
                // }
            })
        } 
        // else {
        //     alert('Что-то пошло не так!')
        // }
        // return false
    }

    createSetting() {

        let _this = this

        let parentShow = $('.popup__card.popup-view__card > .popup-view__figure')
        parentShow[0].style.position = 'relative'
        parentShow[0].style.overflow = 'hidden'
        this.canvasShow = document.createElement('canvas')
        this.canvasShow.setAttribute('id','canvas-show')
        this.canvasShow.style.position = 'absolute'
        parentShow.append(this.canvasShow)

        let parentSetting = $('.popup-fitting__step.popup-fitting__step--2 > .popup-fitting__step-content > .popup-fitting__set')
        parentSetting[0].style.position = 'relative'
        parentSetting[0].style.overflow = 'hidden'
        this.canvasSetting = document.createElement('canvas')
        this.canvasSetting.setAttribute('id','canvas-setting')
        this.canvasSetting.style.position = 'absolute'
        this.canvasSetting.style.left = 0
        parentSetting.append(this.canvasSetting)

        let canvas = this.canvasSetting
        this.ctx = canvas.getContext('2d')

        let pointsSer = this.get_cookie('points')
        this.points = new Array()
        if (pointsSer) {
            this.points = this.unserialize(pointsSer)
        }

        let drag = null

        canvas.addEventListener("mousedown", function(event) {
            event.preventDefault()
            let p = _this.get_mouse_position(event)
            for (let i = 0; i < _this.points.length; i++) {
                let x = _this.points[i][0]
                let y = _this.points[i][1]
                if (p.x < x + 15 && p.x > x - 15 && p.y < y + 15 && p.y > y - 15) {
                    drag = i
                    break
                }
            }
        }, false)

        canvas.addEventListener("mousemove", function(event) {
            event.preventDefault()
            if (drag == null) {
                return
            }
            let p = _this.get_mouse_position(event)
            _this.points[drag][0] = p.x
            _this.points[drag][1] = p.y
            _this.draw_dots_lines(_this.points, _this.ctx)
        }, false)

        canvas.addEventListener("mouseup", function(event) {
            event.preventDefault()
            if (drag == null) {
                //Добавляем точку
                if (_this.points.length < 6) {
                    let mousePos = _this.get_mouse_canvas_position(this, event)
                    let dot = new Array(mousePos.x, mousePos.y)
                    _this.points[_this.points.length] = dot
                    _this.points = _this.sort(_this.points)
                    _this.draw_dots_lines(_this.points, _this.ctx)
                } else {
                    alert('Максимальное количество точек — 6. \n\nНажмите «Очистить точки», чтобы расставить точки заново. \nНажмите «Сохранить», если точки расставлены правильно по контуру фартука')
                }
            } else {
                //Перемещаем точку
                let p = _this.get_mouse_position(event)
                _this.points[drag][0] = p.x
                _this.points[drag][1] = p.y
                _this.draw_dots_lines(_this.points, _this.ctx)
                drag = null
            }
        }, false)

        canvas.addEventListener("contextmenu", function(event) {
            event.preventDefault()
            let p = _this.get_mouse_position(event)
            for (let i = 0; i < _this.points.length; i++) {
                let x = _this.points[i][0]
                let y = _this.points[i][1]
                if (p.x < x + 15 && p.x > x - 15 && p.y < y + 15 && p.y > y - 15) {
                    _this.points.splice(i, 1)
                break
                }
            }
            _this.draw_dots_lines(_this.points, _this.ctx)
        }, false)

        canvas.addEventListener("mouseout", function(event) {
            event.preventDefault()
            drag = null
        }, false)

        canvas.addEventListener("mouseenter", function(event) {
            event.preventDefault()
            drag = null
        }, false)

    }

    newPhoto(obj) {
        $(".primerka_message").html('')
        $(".popup-fitting__step--2").removeClass("active")
        $(".popup-fitting__step--3").removeClass("active")
        $(".popup-fitting__step--1").addClass("active")  
        let parent = obj.closest('.popup-fitting__content')
        let loader = parent.querySelector('.popup-fitting__upload-loader')
        loader.style.display = 'none'
    }

    downloadPhoto(obj) {
        let parent = obj.closest('.popup-fitting__content')
        let loader = parent.querySelector('.popup-fitting__upload-loader')
        this.uploadFile(obj.files[0])
        this.updateRowImg()
        loader.style.display = 'block'

    }

    updateRowImg(img) {
        this.set_cookie('kitchen_src',img)
        // let _this = this
        $.ajax({
            url: "/ajax.php?mid=1",
            type: 'POST',
            data: {
                action: 'primerka_fartuka',
                // sid: sid,
                img: img,
                },
            dataType: "json",
    
            success: function callbackName(res)
            {
                if (res['success'])
                {
                    // console.log(res)
                }
                else
                {
                    alert(res['error'])
                }
            },
            // error: function(err){
            //     alert('Ошибка! Попробуйте повотрить запрос. Error: ' + err)
            // }
            // return false
        })
    }

    updateRowPoints(points) {
        if(points.length == 0) {
            points = 'clear'
        }
        // let _this = this
        $.ajax({
            url: "/ajax.php?mid=1",
            type: 'POST',
            data: {
                action: 'primerka_fartuka',
                points: points,
                },
            dataType: "json",
    
            success: function callbackName(res)
            {
                if (res['success'])
                {
                    // _this.set_cookie('kitchen_points', _this.serialize(_this.changePointsProportions(points)))
                }
                else
                {
                    alert(res['error'])
                }
            },
            // error: function(err){
            //     alert('Ошибка! Попробуйте повотрить запрос. Error: ' + err)
            // }
            // return false
        })
    }

    editPoints() {
        $(".primerka_message").html('')
        $(".popup-fitting__step--3").removeClass("active")
        $(".popup-fitting__step--2").addClass("active")
        this.setSetting()
    }

    clearPoints() {
        $(".primerka_message span").html('')
        this.points = new Array()
        this.draw_dots_lines(this.points, this.ctx)
        $(".popup-fitting__step--3").removeClass("active")
        $(".popup-fitting__step--2").addClass("active")
        this.set_cookie('points', '')
        this.set_cookie('kitchen_points', '')
        this.updateRowPoints(this.points)
    }

    savePoints() {
        $(".primerka_message").html('')
        if (this.points.length != 4 && this.points.length != 6) {
            $(".primerka_message").html('<span style="color:red">Отмечено ' + this.points.length + ' точек. Отметьте 4 или 6 точек и нажмите Сохранить</span>')
        } else {
            $(".popup-fitting__step--2").removeClass("active")
            $(".popup-fitting__step--3").addClass("active")
            this.set_cookie('points', this.serialize(this.points))
            let points = this.changePointsProportions(this.points)
            this.set_cookie('kitchen_points', this.serialize(points))
            this.set_cookie('view_points', JSON.stringify(points))
            this.updateRowPoints(points)
            this.setSetting()
            this.setShow()
        }
    }

    changePointsProportions(points) {
        let index_x = this.canvasShow.width / this.canvasSetting.width
        let index_y = this.canvasShow.height / this.canvasSetting.height
        let view_points = new Array()
        points.forEach(function(entry) {
            view_points.push([Math.round(entry[0] * index_x), Math.round(entry[1] * index_y)])
        })
        return view_points
    }

    getContainedSize(img) {
        let ratio = img.naturalWidth/img.naturalHeight
        let width = img.height*ratio
        let height = img.height
        if (width > img.width) {
            width = img.width
            height = img.width/ratio
        }
        return [width, height]
    }

    setSetting() {
        this.draw_dots_lines(this.points, this.ctx)
    }

    setShow(obj = undefined) {

        let _this = this

        let id
        let src
        let alt

        if(obj) {
            if(obj.nodeName == 'A') {
                id = obj.attributes['data-id'].value
                src = obj.querySelector('.catalog-item__image-container > img').attributes['src'].value
                alt = obj.querySelector('.catalog-item__image-container > img').attributes['alt'].value
            }
            if(obj.nodeName == 'BUTTON') {
                id = obj.closest('li.catalog__table-item').querySelector('a.catalog-item__link').attributes['data-id'].value
                src = obj.closest('li.catalog__table-item').querySelector('a.catalog-item__link > .catalog-item__image-container > img').attributes['src'].value
                alt = obj.closest('li.catalog__table-item').querySelector('a.catalog-item__link > .catalog-item__image-container > img').attributes['alt'].value
            }
            this.set_cookie('fartuk_id', id)
            this.set_cookie('fartuk_src', src)
            this.set_cookie('fartuk_alt', alt)
        }

        let step = undefined
        if($('.popup-fitting__step.popup-fitting__step--2').hasClass('active'))
            step = $('.popup-fitting__step.popup-fitting__step--2')[0]
        if($('.popup-fitting__step.popup-fitting__step--3').hasClass('active'))
            step = $('.popup-fitting__step.popup-fitting__step--3')[0]
        let imgSetting = step.querySelector('img.img_setting')

        this.canvasSetting.width = imgSetting.clientWidth
        this.canvasSetting.height = imgSetting.clientHeight

        let parent = $('.popup__card.popup-view__card > .popup-view__figure')
        let imgShow = parent[0].children[0]

        this.canvasShow.width = imgShow.clientWidth
        this.canvasShow.height = imgShow.clientHeight

        let size = this.getContainedSize(imgShow)
        let left = (imgShow.width - size[0])/2
        let top = (imgShow.height - size[1])/2
        
        this.canvasShow.style.left = left + 'px'
        this.canvasShow.style.top = top + 'px'
        this.canvasShow.width = size[0]
        this.canvasShow.height = size[1]

        this.set_cookie('kitchen_points', this.serialize(this.changePointsProportions(this.points)))

        let cookie_points = this.get_cookie('kitchen_points')
        let cookie_kithen_src = this.get_cookie('kitchen_src')

        if(cookie_points !== undefined || cookie_points !== '' || cookie_kithen_src !== undefined || cookie_kithen_src !== ''){

            let primerkaId =  this.get_cookie('fartuk_id')
            let primerkaSrc = this.get_cookie('fartuk_src').replace(/\/small_/, '/')
            let primerkaAlt =  this.get_cookie('fartuk_alt')

            let canvas = document.getElementById("canvas-show")
            let ctx = canvas.getContext('2d')
            let canvas1 = document.createElement('canvas')
            canvas1.width = $(canvas).attr('width')
            canvas1.height = $(canvas).attr('height')
            let ctx1 = canvas1.getContext('2d')
            let canvas2 = document.createElement('canvas')
            canvas2.width = $(canvas).attr('width')
            canvas2.height = $(canvas).attr('height')
            let ctx2 = canvas2.getContext('2d')

            let basePoints = this.unserialize(cookie_points)
            let points = new Array()
            let pointsOriginal =  new Array()

            for(let i in basePoints){
                points[points.length] = [basePoints[i][0], basePoints[i][1]]
                pointsOriginal[pointsOriginal.length] = [basePoints[i][0], basePoints[i][1]]
            }

            let points2 = new Array()

            if(points.length==6) {
                points.splice(2,2)  //Убираем крайние правые точки для углового фартука
                for(let i in basePoints){
                    if(i != 0 && i != 5){
                        points2[points2.length] = [basePoints[i][0], basePoints[i][1]]
                    }
                }
            }

            let img = new Image()
            
            img.id = primerkaId
            img.src = primerkaSrc
            img.alt = primerkaAlt

            img.onload = function() {
                let op = new Perspective(ctx1, img, 1, pointsOriginal)
                op.draw(points)
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
                _this.draw_canvas(ctx, ctx1, ctx2);
            }

            if(points2 !== undefined) {
                let canvas3 = document.createElement('canvas')
                canvas3.width = canvas.width
                canvas3.height = canvas.height
                let ctx3 = canvas3.getContext('2d')
                let canvas4 = document.createElement('canvas')
                canvas4.width = canvas.width
                canvas4.height = canvas.height
                let ctx4 = canvas4.getContext('2d')
                // img
                let img2 = new Image()
                this.flip(primerkaSrc, img2)
                img2.onload = function() {
                    setTimeout(function(){
                        let op2 = new Perspective(ctx3, img2, 2, pointsOriginal)
                        op2.draw(points2)
                        _this.draw_canvas(ctx, ctx3, ctx4)
                    }, 1)
                }
            }

        }

    }

    setAll() {
        this.setShow()
        this.setSetting()
    }

    vect(a, b) {
        let res = a[0] * b[1] - a[1] * b[0]
        console.log('vect')
        return res
    }

    comp(a, b) {
        if (a[0] < b[0])
            return -1 // Или любое число, меньшее нуля
        if (a[0] > b[0])
            return 1 // Или любое число, большее нуля
        // в случае а = b вернуть 0
        return 0
    }

    sort(points) {
        let count = points.length
        if (count < 4)
            return points
        let pointsSorted = points.sort(this.comp)
        let pointsTmp = new Array()
        let k = 0
        if (pointsSorted[0][1] < pointsSorted[1][1]) {
            pointsTmp[k] = pointsSorted[0] //Верхняя левая точка фартука
            pointsTmp[count - 1] = pointsSorted[1] //Нижняя левая точка фартука
        } else {
            pointsTmp[k] = pointsSorted[1]
            pointsTmp[count - 1] = pointsSorted[0]
        }
        k++;
        if (count == 5) {
            pointsTmp[k] = pointsSorted[2]
            k++
        } else if (count == 6) {
            if (pointsSorted[2][1] < pointsSorted[3][1]) {
                pointsTmp[k] = pointsSorted[2] //Верхняя средняя точка фартука
                pointsTmp[count - 2] = pointsSorted[3] //Нижняя средняя точка фартука
            } else {
                pointsTmp[k] = pointsSorted[3]
                pointsTmp[count - 2] = pointsSorted[2]
            }
            k++
        }
        if (pointsSorted[count - 2][1] < pointsSorted[count - 1][1]) {
            pointsTmp[k] = pointsSorted[count - 2]
            k++
            pointsTmp[k] = pointsSorted[count - 1]
        } else {
            pointsTmp[k] = pointsSorted[count - 1]
            k++
            pointsTmp[k] = pointsSorted[count - 2]
        }
        // console.log('sort')
        // console.log(pointsTmp)
        return pointsTmp
    }

    delete_cookies() {
        const cookies = document.cookie.split(";")
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i]
            const eqPos = cookie.indexOf("=")
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT"
        }
    }

    set_cookie(name, value, expires) {
        if (!expires) {
            expires = new Date();
            expires.setDate(expires.getDate() + 30);
        }
        document.cookie = name + "=" + escape(value) + "; expires=" + expires + "; path=/";
    }

    get_cookie(cookie_name) {
        let results = document.cookie.match('(^|;) ?' + cookie_name + '=([^;]*)(;|$)')
        if (results)
            return (unescape(results[2]))
        else
            return null
    }

    delete_cookie(cookie_name) {
        let cookie_date = new Date()  // Текущая дата и время
        cookie_date.setTime(cookie_date.getTime() - 1)
        document.cookie = cookie_name += "=; expires=" + cookie_date.toGMTString()
    }

    draw_dots_lines(points, ctx) {
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
        for (let $i = 0; $i < points.length; $i++) {
            ctx.beginPath()
            ctx.arc(points[$i][0], points[$i][1], 4, 0, Math.PI * 2, true)
            ctx.fillStyle = "rgb(0,210,255)"
            ctx.fill()
        }
        ctx.closePath()
        if (points.length > 1) {
            ctx.beginPath()
            ctx.moveTo(points[0][0], points[0][1])
            for (let $i = 1; $i < points.length; $i++) {
                ctx.lineTo(points[$i][0], points[$i][1])
            }
            ctx.closePath()
            ctx.strokeStyle = "skyblue"
            ctx.stroke()
        }
    }

    unserialize(inp) {
        let error = 0
        let errormsg
        if (inp == undefined || inp == "" || inp.length < 2) {
            errormsg = "input is too short"
            return
        }
        let val, kret, vret, cval
        let type = inp.charAt(0)
        let cont = inp.substring(2)
        let size = 0, divpos = 0, endcont = 0, rest = "", next = ""

        switch (type) {
            case "N": // null
                if (inp.charAt(1) != ";") {
                    errormsg = "missing ; for null"
                }
                // leave val undefined
                rest = cont
                break
            case "b": // boolean
                if (!/[01];/.test(cont.substring(0, 2))) {
                    errormsg = "value not 0 or 1, or missing ; for boolean"
                }
                val = (cont.charAt(0) == "1")
                rest = cont.substring(1)
                break
            case "s": // string
                val = ""
                divpos = cont.indexOf(":")
                if (divpos == -1) {
                    errormsg = "missing : for string"
                    break
                }
                size = parseInt(cont.substring(0, divpos))
                if (size == 0) {
                    if (cont.length - divpos < 4) {
                        errormsg = "string is too short"
                        break
                    }
                    rest = cont.substring(divpos + 4)
                    break
                }
                if ((cont.length - divpos - size) < 4) {
                    errormsg = "string is too short"
                    break
                }
                if (cont.substring(divpos + 2 + size, divpos + 4 + size) != "\";") {
                    errormsg = "string is too long, or missing \";"
                }
                val = cont.substring(divpos + 2, divpos + 2 + size)
                rest = cont.substring(divpos + 4 + size)
                break
            case "i": // integer
            case "d": // float
                let dotfound = 0
                for (let i = 0; i < cont.length; i++) {
                    cval = cont.charAt(i)
                    if (isNaN(parseInt(cval)) && !(type == "d" && cval == "." && !dotfound++)) {
                        endcont = i
                        break
                    }
                }
                if (!endcont || cont.charAt(endcont) != ";") {
                    errormsg = "missing or invalid value, or missing ; for int/float"
                }
                val = cont.substring(0, endcont)
                val = (type == "i" ? parseInt(val) : parseFloat(val))
                rest = cont.substring(endcont + 1)
                break
            case "a": // array
                if (cont.length < 4) {
                    errormsg = "array is too short"
                    return
                }
                divpos = cont.indexOf(":", 1)
                if (divpos == -1) {
                    errormsg = "missing : for array"
                    return
                }
                size = parseInt(cont.substring(1, divpos - 1))
                cont = cont.substring(divpos + 2)
                val = new Array()
                if (cont.length < 1) {
                    errormsg = "array is too short"
                    return
                }
                for (let i = 0; i + 1 < size * 2; i += 2) {
                    kret = this.unserialize(cont, 1)
                    if (error || kret[0] == undefined || kret[1] == "") {
                        errormsg = "missing or invalid key, or missing value for array"
                        return
                    }
                    vret = this.unserialize(kret[1], 1);
                    if (error) {
                        errormsg = "invalid value for array"
                        return
                    }
                    val[kret[0]] = vret[0]
                    cont = vret[1]
                }
                if (cont.charAt(0) != "}") {
                    errormsg = "missing ending }, or too many values for array"
                    return
                }
                rest = cont.substring(1)
                break
            case "O": // object
                divpos = cont.indexOf(":")
                if (divpos == -1) {
                    errormsg = "missing : for object"
                    return
                }
                size = parseInt(cont.substring(0, divpos))
                let objname = cont.substring(divpos + 2, divpos + 2 + size)
                if (cont.substring(divpos + 2 + size, divpos + 4 + size) != "\":") {
                    errormsg = "object name is too long, or missing \":"
                    return
                }
                let objprops = unserialize("a:" + cont.substring(divpos + 4 + size), 1)
                if (error) {
                    errormsg = "invalid object properties"
                    return
                }
                rest = objprops[1]
                let objout = "function " + objname + "(){"
                for (let key in objprops[0]) {
                    objout += "" + key + "=objprops[0]['" + key + "'];"
                }
                objout += "}val=new " + objname + "();"
                eval(objout)
                break
            default:
                errormsg = "invalid input type"
        }
        return (arguments.length == 1 ? val : [val, rest])
    }

    serialize(mixed_val) {
        switch (typeof(mixed_val)) {
            case "number":
                if (isNaN(mixed_val) || !isFinite(mixed_val)) {
                    return false
                } else {
                    return (Math.floor(mixed_val) == mixed_val ? "i" : "d") + ":" + mixed_val + ";"
                }
            case "string":
                return "s:" + mixed_val.length + ":\"" + mixed_val + "\";"
            case "boolean":
                return "b:" + (mixed_val ? "1" : "0") + ";"
            case "object":
                if (mixed_val == null) {
                    return "N;"
                } else if (mixed_val instanceof Array) {
                    let idxobj = {idx: -1}
                    let map = []
                    for (let i = 0; i < mixed_val.length; i++) {
                        idxobj.idx++
                        let ser = this.serialize(mixed_val[i])

                        if (ser) {
                            map.push(this.serialize(idxobj.idx) + ser)
                        }
                    }

                    return "a:" + mixed_val.length + ":{" + map.join("") + "}"

                }
                else {
                    let class_name = get_class(mixed_val)

                    if (class_name == undefined) {
                        return false
                    }

                    let props = new Array();
                    for (let prop in mixed_val) {
                        let ser = this.serialize(mixed_val[prop])

                        if (ser) {
                            props.push(this.serialize(prop) + ser)
                        }
                    }
                    return "O:" + class_name.length + ":\"" + class_name + "\":" + props.length + ":{" + props.join("") + "}"
                }
            case "undefined":
                return "N;"
        }
        return false
    }

    draw_canvas(ctx, ctx1, ctx2) {
        // ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)
        ctx.drawImage(ctx1.canvas, 0, 0)
        ctx.drawImage(ctx2.canvas, 0, 0)
    }

    get_mouse_canvas_position(canvas, evt) {
        let rect = canvas.getBoundingClientRect()
        return {
            x: Math.round(evt.clientX) - Math.round(rect.left),
            y: Math.round(evt.clientY) - Math.round(rect.top)
        }
    }

    get_mouse_position(event) {
        let rect = event.target.getBoundingClientRect() 
        return {
            x: Math.round(event.clientX) - Math.round(rect.left),
            y: Math.round(event.clientY) - Math.round(rect.top)
        }
    }

    getDistance(a,b) {
        return Math.pow(Math.pow(a[0]-b[0],2)+Math.pow(a[1]-b[1],2),0.5)
    }

    in_array(value, array) {
        for (let i = 0; i < array.length; i++) {
            if (array[i] == value) return true
        }
        return false
    }

    prepare_lines(ctx, p, with_line) {
        ctx.save()
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height)

        if( with_line == true ) {
            ctx.beginPath()
            ctx.moveTo(p[0][0], p[0][1])
            for( let i=1; i<4; i++ ) {
                ctx.lineTo(p[i][0], p[i][1])
            }
            ctx.closePath()
            ctx.strokeStyle = "red"
            ctx.stroke()
        }

        ctx.fillStyle = "red"
        for( let i=0; i<4; i++ ) {
            ctx.beginPath()
            ctx.arc(p[i][0], p[i][1], 4, 0, Math.PI*2, true)
            ctx.fill()
        }

        ctx.restore()
    }

    flip(src,target){
        let img = new Image()
        img.onload = function(){
            let c = document.createElement('canvas')
            c.width = this.width
            c.height = this.height
            let ctx = c.getContext('2d')
            ctx.scale(-1,1)
            ctx.drawImage(this,-this.width,0)
            this.onload = undefined
            // target.src = c.toDataURL() // ???
        }
        img.src = src
        target.src = src
    }

    uploadFile(file)
    {
        let _this = this
        let url = '/ajax.php?mid=1&action=put_file'
        if (file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/png') 
        {
            let reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = function() {  
                let xhr = new XMLHttpRequest()
                xhr.onreadystatechange = function () {
                    if (this.readyState == 4) {
                        if(this.status == 200) {
                            let res = $.parseJSON(this.response)
                            $('img.popup-view__image').attr('src',res.filename)
                            $('img.popup-fitting__set-image').attr('src',res.filename)
                            $('.popup-fitting__step.popup-fitting__step--3 > .popup-fitting__step-teaser > .text-block > img').attr('src',res.filename)
                            $(".popup-fitting__step--1").removeClass("active")
                            $(".popup-fitting__step--2").addClass("active")
                            _this.clearPoints()
                            _this.updateRowImg(res.filename)
                            setTimeout(function(){_this.setSetting();_this.setShow()}, 1000);
                            // _this.setSetting()
                            // _this.setShow()
                        } else {
                            alert('Ошибка загрузки изображения на сервер!')
                        }
                    }
                }
                xhr.open("POST", url)
                let formData = new FormData()
                formData.append('myFile', file)
                xhr.send(formData)
            }
        } else {
            let errorMessage = document.querySelector('.form__mistakes')
            errorMessage.style.display = 'block'
            errorMessage.append('Данный формат изображения не поддерживается на сайте!')
        }
        // return res
    }

    setOrderSkinali(obj) {

        let alt = this.get_cookie('fartuk_alt')
        let src = this.get_cookie('fartuk_src')

        if(alt !== undefined || alt !== '') {
            $('.articul_img').html('')
            $('.articul_img').append('Изображение №: ' + alt)
            $('#idSkinali').val(alt)
        }

        if(src !== undefined || src !== '') {
            $('img.popup-order__image').attr('src',src)
        }

    }

    sendPostOrderSkinali(event,obj) {
        // NS_BINDING_ABORTED
        event.preventDefault()

        let _this = this

        $.ajax({
            url: "/ajax.php?mid=1",
            type: 'POST',
            data: {
                action: 'order_skinali',
                name: obj[0].value,
                tel: obj[1].value,
                email: obj[2].value,
                skinali: _this.get_cookie('fartuk_id'),
                },
            dataType: "json",
    
            success: function callbackName(res)
            {
                if (res['success'])
                {
                    obj.closest('.popup-order').classList.remove('active')
                    // console.log(res)
                }
                else
                {
                    alert(res['error'])
                }
            },
            // error: function(err){
            //     alert('Ошибка! Попробуйте повотрить запрос. Error: ' + err)
            // }
        })
        return false

    }

}

class Perspective {

    constructor(ctxd, image, side, pointsOr) {
        const primerka = new Primerka();
        if( ! ctxd || ! ctxd.strokeStyle ) { return }
        if( ! image || ! image.width || ! image.height ) { return }
        if( !side ) { return }
        if(pointsOr.length == 0) { return }
        // prepare a <canvas> for the image
        let cvso = document.createElement('canvas')
        cvso.width = parseInt(image.width)
        cvso.height = parseInt(image.height)
        let ctxo = cvso.getContext('2d')
        if(cvso.height<210) {
            let koef = Math.pow(Math.pow(pointsOr[3][0]-pointsOr[2][0],2)+Math.pow(pointsOr[3][1]-pointsOr[2][1],2),0.5)/cvso.width
            if(pointsOr.length == 6) {
                let leftSide = primerka.getDistance(pointsOr[5],pointsOr[4])
                koef = leftSide/(leftSide+primerka.getDistance(pointsOr[4],pointsOr[3]))
            }

            if(side == 1)
                ctxo.drawImage(image,0,0,koef*cvso.width,cvso.height, 0, 0, cvso.width, cvso.height)
            else
                ctxo.drawImage(image,koef*cvso.width,0,(1-koef)*cvso.width,cvso.height, 0, 0, cvso.width, cvso.height)
        }
        else
            ctxo.drawImage(image,0, 0, cvso.width, cvso.height)
        // prepare a <canvas> for the transformed image
        let cvst = document.createElement('canvas')
        cvst.width = ctxd.canvas.width
        cvst.height = ctxd.canvas.height
        let ctxt = cvst.getContext('2d')
        // parameters
        this.p = {
            ctxd: ctxd,
            cvso: cvso,
            ctxo: ctxo,
            ctxt: ctxt
        }
    }

    draw(points) {
        if (points.length != 0) {
            let d0x = points[0][0]
            let d0y = points[0][1]
            let d1x = points[1][0]
            let d1y = points[1][1]
            let d2x = points[2][0]
            let d2y = points[2][1]
            let d3x = points[3][0]
            let d3y = points[3][1]
            // compute the dimension of each side
            let dims = [
                Math.sqrt( Math.pow(d0x-d1x, 2) + Math.pow(d0y-d1y, 2) ), // top side
                Math.sqrt( Math.pow(d1x-d2x, 2) + Math.pow(d1y-d2y, 2) ), // right side
                Math.sqrt( Math.pow(d2x-d3x, 2) + Math.pow(d2y-d3y, 2) ), // bottom side
                Math.sqrt( Math.pow(d3x-d0x, 2) + Math.pow(d3y-d0y, 2) )  // left side
            ]
            //
            let ow = this.p.cvso.width
            let oh = this.p.cvso.height
            // specify the index of which dimension is longest
            let base_index = 0
            let max_scale_rate = 0
            let zero_num = 0
            for( let i=0; i<4; i++ ) {
                let rate = 0
                if( i % 2 ) {
                    rate = dims[i] / ow
                } else {
                    rate = dims[i] / oh
                }
                if( rate > max_scale_rate ) {
                    base_index = i
                    max_scale_rate = rate
                }
                if( dims[i] == 0 ) {
                    zero_num ++
                }
            }
            if(zero_num > 1) { return }
            //
            let step = 1
            let cover_step = step * 5
            //
            let ctxo = this.p.ctxo
            let ctxt = this.p.ctxt
            ctxt.clearRect(0, 0, ctxt.canvas.width, ctxt.canvas.height)
            if(base_index % 2 == 0) { // top or bottom side
                let ctxl = this.create_canvas_context(ow, cover_step)
                let cvsl = ctxl.canvas
                for( let y=0; y<oh; y+=step ) {
                    let r = y / oh
                    let sx = d0x + (d3x-d0x) * r
                    let sy = d0y + (d3y-d0y) * r
                    let ex = d1x + (d2x-d1x) * r
                    let ey = d1y + (d2y-d1y) * r
                    let ag = Math.atan( (ey-sy) / (ex-sx) )
                    let sc = Math.sqrt( Math.pow(ex-sx, 2) + Math.pow(ey-sy, 2) ) / ow
                    ctxl.setTransform(1, 0, 0, 1, 0, -y)
                    ctxl.drawImage(ctxo.canvas, 0, 0)
                    //
                    ctxt.translate(sx, sy)
                    ctxt.rotate(ag)
                    ctxt.scale(sc, sc)
                    ctxt.drawImage(cvsl, 0, 0)
                    //
                    ctxt.setTransform(1, 0, 0, 1, 0, 0)
                }
            } else if(base_index % 2 == 1) { // right or left side
                let ctxl = this.create_canvas_context(cover_step, oh)
                let cvsl = ctxl.canvas
                for( let x=0; x<ow; x+=step ) {
                    let r =  x / ow
                    let sx = d0x + (d1x-d0x) * r
                    let sy = d0y + (d1y-d0y) * r
                    let ex = d3x + (d2x-d3x) * r
                    let ey = d3y + (d2y-d3y) * r
                    let ag = Math.atan( (sx-ex) / (ey-sy) )
                    let sc = Math.sqrt( Math.pow(ex-sx, 2) + Math.pow(ey-sy, 2) ) / oh
                    ctxl.setTransform(1, 0, 0, 1, -x, 0)
                    ctxl.drawImage(ctxo.canvas, 0, 0)
                    //
                    ctxt.translate(sx, sy)
                    ctxt.rotate(ag)
                    ctxt.scale(sc, sc)
                    ctxt.drawImage(cvsl, 0, 0)
                    //
                    ctxt.setTransform(1, 0, 0, 1, 0, 0)
                }
            }
            // set a clipping path and draw the transformed image on the destination canvas.
            this.p.ctxd.save()
            this.set_clipping_path(this.p.ctxd, [[d0x, d0y], [d1x, d1y], [d2x, d2y], [d3x, d3y]])
            this.p.ctxd.drawImage(ctxt.canvas, 0, 0)
            this.p.ctxd.restore()
        }
    }

    create_canvas_context(w, h) {
        let canvas = document.createElement('canvas')
        canvas.width = w
        canvas.height = h
        let ctx = canvas.getContext('2d')
        return ctx
    }

    set_clipping_path(ctx, points) {
        ctx.beginPath()
        ctx.moveTo(points[0][0], points[0][1])
        for( let i=1; i<points.length; i++ ) {
            ctx.lineTo(points[i][0], points[i][1])
        }
        ctx.closePath()
        ctx.clip()
    }

}